"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readback = void 0;
const readback_1 = require("../readback");
const solution_1 = require("../solution");
/**

   # readback

   Note that we view "readback" as one word,
   thus we write `readback` instead of `readBack`.

   We will use `readback` to implement `equivalent` between values.

   Be careful about the order of arguments of `readback`,
   first the `type`, then the `value`.

**/
function readback(mod, ctx, type, value) {
    type = (0, solution_1.solutionAdvanceValue)(mod, type);
    value = (0, solution_1.solutionAdvanceValue)(mod, value);
    return ((0, readback_1.readbackByType)(mod, ctx, type, value) ||
        (0, readback_1.readbackByValue)(mod, ctx, type, value));
}
exports.readback = readback;
//# sourceMappingURL=readback.js.map